export default ({ commit }, expiredStatus) => {
  window.localStorage.removeItem('token')
  window.localStorage.removeItem('permissions')
  commit('SET_EXPIRED_STATUS', expiredStatus)
}



// WEBPACK FOOTER //
// ./src/view/login/state/action/ForceExpire.js